module.exports = __webpack_public_path__ + "static/img/far1_active.e9ad8ac4.png";